import React from "react";
import { Box, CircularProgress } from "@mui/material";

const AppCircularProgress = () => {
  return (
    <Box display="flex" justifyContent="center" mt={5}>
      <CircularProgress color="primary" />
    </Box>
  );
};

export default AppCircularProgress;
